"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _commonAccordion = require("@mmc/common-accordion");
var _commonRichText = require("@mmc/common-rich-text");
var _disclaimer = _interopRequireDefault(require("./disclaimer.css"));
var Disclaimer = function Disclaimer(_ref) {
  var headline = _ref.headline,
    content = _ref.content,
    theme = _ref.theme;
  return /*#__PURE__*/_react["default"].createElement(_commonAccordion.CommonAccordion, {
    theme: theme,
    headerClasses: [_disclaimer["default"].accordionNoBorder, _disclaimer["default"].accordionHeaderClasses],
    panelClasses: [_disclaimer["default"].accordionNoBorder, _disclaimer["default"].accordionPanelClasses]
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h3", null, headline), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
    html: content,
    format: "inherit",
    theme: theme
  }))));
};
var _default = /*#__PURE__*/_react["default"].memo(Disclaimer);
exports["default"] = _default;